import produce from 'immer';

import { UNSUBSCRIBE_FAILED, RESET_UNSUBSCRIPTION, LOGOUT } from '../../constants/actionTypes';

const initState = 0;

export default produce((draft, action) => {
  switch (action.type) {
    case UNSUBSCRIBE_FAILED: {
      return draft + 1;
    }

    case RESET_UNSUBSCRIPTION:
    case LOGOUT: {
      return initState;
    }
  }
}, initState);
